import { http } from '@services/http'

export const downloadExcel = async ({
	url,
	params,
	fileName,
	onLoadingChange,
	method = 'post',
}) => {
	try {
		onLoadingChange?.(true)

		const response = await http.request({
			url,
			method,
			...(method === 'get'
				? { params }
				: {
						data: params,
					}),
			headers: {
				'Content-Type': 'application/json',
			},
			responseType: 'blob',
		})

		const blob = new Blob([response.data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		})

		const fileUrl = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = fileUrl
		const filename = `${fileName}.xlsx`
		link.setAttribute('download', filename)

		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
		window.URL.revokeObjectURL(fileUrl)

		return { success: true }
	} catch (error) {
		console.error('Error downloading Excel file:', error)
		return { success: false, error }
	} finally {
		onLoadingChange?.(false)
	}
}
